import LocalStorageKeys from '@/constants/LOCAL_STORAGE_KEYS';

const state = {
  isUserPropertyFilterShowable: false,
  isLoadingUserProperties: false,
  userWeight: null,
  userHeight: null
};

const mutations = {
  SET_IS_USER_PROPERTY_FILTER_SHOWABLE(state, isUserPropertyFilterShowable) {
    state.isUserPropertyFilterShowable = isUserPropertyFilterShowable;
  },
  SET_IS_LOADING_USER_PROPERTIES(state, isLoadingUserProperties) {
    state.isLoadingUserProperties = isLoadingUserProperties;
  },
  SET_USER_WEIGHT(state, userWeight) {
    state.userWeight = userWeight;
  },
  SET_USER_HEIGHT(state, userHeight) {
    state.userHeight = userHeight;
  }
};

const actions = {
  fetchUserPropertyFilterShowable({ commit, rootState, dispatch }, params) {
    return rootState.api
      .fetchUserPropertyFilterShowable(params)
      .then(({ data }) => {
        commit('SET_IS_USER_PROPERTY_FILTER_SHOWABLE', data.showable);
        if (data.showable) return dispatch('fetchUserProperties', params);
      });
  },
  fetchUserProperties({ commit, rootState }, params) {
    commit('SET_IS_LOADING_USER_PROPERTIES', true);
    return rootState.api
      .fetchUserProperties(params)
      .then(({ data }) => {
        if (data.user_property_option_ids) {
          localStorage.setItem(
            LocalStorageKeys.WEIGHT_OPTION_ID,
            data.user_property_option_ids.weight
          );
          localStorage.setItem(
            LocalStorageKeys.HEIGHT_OPTION_ID,
            data.user_property_option_ids.height
          );
        }

        const savedUserWeight = JSON.parse(
          localStorage.getItem(LocalStorageKeys.USER_WEIGHT)
        );
        const savedUserHeight = JSON.parse(
          localStorage.getItem(LocalStorageKeys.USER_HEIGHT)
        );

        if (data.user_properties && !(savedUserWeight || savedUserHeight)) {
          localStorage.setItem(
            LocalStorageKeys.USER_WEIGHT,
            data.user_properties.weight
          );
          localStorage.setItem(
            LocalStorageKeys.USER_HEIGHT,
            data.user_properties.height
          );
        }
      })
      .finally(() => {
        commit('SET_IS_LOADING_USER_PROPERTIES', false);
      });
  }
};

export default { namespaced: true, state, mutations, actions };
